import openFlexPaneHelper from 'owa-app-pane-group-utils/lib/helpers/openFlexPaneHelper';

export function toggleTimePanel(): void {
    openFlexPaneHelper('OwaTimePanel', 'myDay');
}
